import React from 'react';

const ContactActions = ({ record, className = '' }) => {
  const getSocialUrl = (platform, username) => {
    if (!username) return null;
    
    // 移除 @ 符號和空格
    const cleanUsername = username.replace(/[@\s]/g, '');
    
    switch (platform) {
      case 'facebook':
        return `https://facebook.com/${cleanUsername}`;
      case 'twitter':
        return `https://twitter.com/${cleanUsername}`;
      case 'linkedin':
        return `https://linkedin.com/in/${cleanUsername}`;
      default:
        return null;
    }
  };

  const handleCall = (phone) => {
    if (phone) {
      window.location.href = `tel:${phone}`;
    }
  };

  const handleEmail = (email) => {
    if (email) {
      window.location.href = `mailto:${email}`;
    }
  };

  const handleSocialLink = (platform, username) => {
    const url = getSocialUrl(platform, username);
    if (url) {
      window.open(url, '_blank');
    }
  };

  const handleWebsite = (website) => {
    if (website) {
      let url = website;
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = `https://${url}`;
      }
      window.open(url, '_blank');
    }
  };

  // 從記錄中提取聯繫信息
  const phone = record['電話'] || record['Phone'] || record['手機'] || record['Mobile'];
  const email = record['Email'] || record['email'] || record['電子郵件'];
  const website = record['網站'] || record['Website'] || record['官網'];
  const facebook = record['Facebook'] || record['facebook'] || record['FB'];
  const twitter = record['Twitter'] || record['twitter'];
  const linkedin = record['LinkedIn'] || record['linkedin'];

  return (
    <div className={`contact-actions ${className}`}>
      {phone && (
        <button 
          onClick={() => handleCall(phone)}
          className="contact-btn call-btn"
          title={`撥打電話: ${phone}`}
        >
          📞
        </button>
      )}
      
      {email && (
        <button 
          onClick={() => handleEmail(email)}
          className="contact-btn email-btn"
          title={`發送郵件: ${email}`}
        >
          📧
        </button>
      )}
      
      {website && (
        <button 
          onClick={() => handleWebsite(website)}
          className="contact-btn website-btn"
          title={`訪問網站: ${website}`}
        >
          🌐
        </button>
      )}
      
      {facebook && (
        <button 
          onClick={() => handleSocialLink('facebook', facebook)}
          className="contact-btn facebook-btn"
          title={`Facebook: ${facebook}`}
        >
          📘
        </button>
      )}
      
      {twitter && (
        <button 
          onClick={() => handleSocialLink('twitter', twitter)}
          className="contact-btn twitter-btn"
          title={`Twitter: ${twitter}`}
        >
          🐦
        </button>
      )}
      
      {linkedin && (
        <button 
          onClick={() => handleSocialLink('linkedin', linkedin)}
          className="contact-btn linkedin-btn"
          title={`LinkedIn: ${linkedin}`}
        >
          💼
        </button>
      )}

      <style jsx="true">{`
        .contact-actions {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
          align-items: center;
        }

        .contact-btn {
          border: none;
          border-radius: 8px;
          padding: 8px 10px;
          cursor: pointer;
          font-size: 16px;
          transition: all 0.3s ease;
          background: rgba(255, 255, 255, 0.3);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.4);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .contact-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .call-btn:hover {
          background: rgba(76, 175, 80, 0.3);
          border-color: rgba(76, 175, 80, 0.6);
        }

        .email-btn:hover {
          background: rgba(33, 150, 243, 0.3);
          border-color: rgba(33, 150, 243, 0.6);
        }

        .website-btn:hover {
          background: rgba(255, 152, 0, 0.3);
          border-color: rgba(255, 152, 0, 0.6);
        }

        .facebook-btn:hover {
          background: rgba(59, 89, 152, 0.3);
          border-color: rgba(59, 89, 152, 0.6);
        }

        .twitter-btn:hover {
          background: rgba(29, 161, 242, 0.3);
          border-color: rgba(29, 161, 242, 0.6);
        }

        .linkedin-btn:hover {
          background: rgba(0, 119, 181, 0.3);
          border-color: rgba(0, 119, 181, 0.6);
        }

        .contact-btn:active {
          transform: translateY(0);
        }

        /* 小屏幕適配 */
        @media (max-width: 768px) {
          .contact-actions {
            gap: 6px;
          }
          
          .contact-btn {
            padding: 6px 8px;
            font-size: 14px;
          }
        }
      `}</style>
    </div>
  );
};

export default ContactActions;